import {AnyAction} from "redux";
import {SET_MAP_BOUNDS} from "./action";


/**
 * set the bounds of the map
 */
export function setMapBounds(width: number, height: number) : AnyAction
{
    return {type: SET_MAP_BOUNDS, payload: {width, height}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/mapBounds.ts